exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".form-control:-moz-read-only{background-color:#fff}.form-control:read-only{background-color:#fff}", "", {"version":3,"sources":["/Users/chakritkanpromkad/Desktop/Sourcetree/Mariminterfood/pos_ui-Develop/src/components/pos/item_detail.vue"],"names":[],"mappings":"AACA,6BAEE,qBAAuB,CACxB,AACD,wBACE,qBAAuB,CACxB","file":"item_detail.vue","sourcesContent":["\n.form-control:-moz-read-only {\n  /* For Firefox */\n  background-color: #fff;\n}\n.form-control:read-only {\n  background-color: #fff;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-77334ce0","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/pos/item_detail.vue
// module id = 1073
// module chunks = 0 3